<app-fm-icon
	*ngIf="showIcon && iconPosition === 'leading'"
	[prefix]="prefix"
	[icon]="icon"
	[color]="linkColor"
	[fontSize]="fontSize"
>
</app-fm-icon>

<ng-content></ng-content>

<app-fm-icon
	*ngIf="showIcon && iconPosition === 'trailing'"
	[prefix]="prefix"
	[icon]="icon"
	[color]="linkColor"
	[fontSize]="fontSize"
>
</app-fm-icon>
